import React, {FC, useCallback, useEffect, useRef, useState} from "react";
import {ComponentTypeID, IAssessment, IAssessmentTemplateDetail, IAssessmentTemplateGroup} from "../types/types";
import {Button, DialogContent, Grid, Paper, TableCell, TextField, TextFieldProps} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Comments from "./comments";
import DataGaps from "./data_gaps";
import {useParams} from "react-router";
import {  useTask } from '../stateManagement/context';

interface IAdequacyDetailProps {
    templates: IAssessmentTemplateDetail[],
    initialAssessment: IAssessment,
    updateAssessment: (assessment: IAssessment) => void;
    template_id: number,
    template_group_id: number,
}

interface IRouteParams {
    id: string
}



const AdequacyDetails: FC<IAdequacyDetailProps> = ({
                                                       templates,
                                                       initialAssessment,
                                                       updateAssessment,
                                                       template_id,
                                                       template_group_id

                                                   }: IAdequacyDetailProps) => {

    const [assessment, setAssessment] = useState<IAssessment>(initialAssessment);
    const [justification, setJustification] = useState<string>(initialAssessment.justification);
    const [templateID, setTemplateID] = useState(initialAssessment.assessment_template_detail_id);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()
    const params = useParams<IRouteParams>()


    useEffect(() => {
        setAssessment(initialAssessment);
        setJustification(initialAssessment.justification);
    }, [setAssessment, initialAssessment, setJustification])

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])



    const handleSelectAssessment = (id: number) => {
        updateAssessment({assessment_template_detail_id: id, justification: justification})
        setTemplateID(id)
    }



    return (
        <div style={{padding: 30}}>

            <Grid container spacing={2} xl={12} direction={"row"} style={{padding: 10, width: "100%"}}>

                <Grid item xs={12} sm={8}>
                    <Paper style={{padding: 10, width: "100%"}}>
                        <Typography variant="h6"> Justification</Typography>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            variant="outlined"
                            type="text"
                            error={(templateID < 0)}
                            helperText={ (templateID < 0) ? "select assessment to store data" : ""}
                            minRows={7}
                            disabled={!write_access}
                            multiline
                            value={justification}
                            onChange={(event) => {
                                setJustification(event.target.value)
                            }}
                            onBlur={(event) => {
                                setJustification(event.target.value)
                                if (templateID > 0) {
                                    updateAssessment({
                                        assessment_template_detail_id: templateID,
                                        justification: event.target.value
                                    })

                                }

                            }}
                            fullWidth

                        />
                    </Paper>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Paper style={{padding: 10, width: "100%"}}>
                        <Typography variant="h6"> Comments</Typography>
                        <Comments parent_uuid={template_id + 10000000 * parseFloat(params.id)} type_id={ComponentTypeID.AssessmentTemplate}/>
                    </Paper>
                </Grid>

                <Grid container spacing={2} xl={12} direction={"row"}
                      style={{padding: 10, width: "100%", overflowY: "auto"}}>
                    {
                        templates.map(t => {

                            let color = "#FFFFFF"
                            let alpha = 1;


                            let bcolor = "rgb(196,196,196)";

                            if (t.adequacy.level === 1) {
                                        bcolor = "rgba(206,238,208," + alpha+ ")";
                                        color = "rgb(48,104,33)";
                            }
                            if (t.adequacy.level === 2) {
                                        bcolor = "rgba(252,236,166," + alpha+ ")";
                                        color = "rgb(152,96,34)";
                            }
                            if (t.adequacy.level === 3) {
                                        bcolor = "rgba(251,84,81," + alpha+ ")";
                                        color = "rgb(104,4,0)";
                            }


                            let s = {}
                            s = { ...s, backgroundColor: bcolor, color: color, padding: 20, height: "100%"}

                            if (assessment.assessment_template_detail_id === t.uuid) {
                                s = ({ ...s,
                                    outline: "4px solid black",
                                    outlineColor: color,
                                    outlineOffset: "-4px"})
                            }



                            return (
                                <Grid item xs={12} sm={4} md={4} lg={4} style={{padding: 5, height: "100%"}}>
                                    <Paper style={s}>
                                        <Grid container spacing={2} xl={12} direction={"row"}>

                                            <Grid item xs={8}>
                                                <Typography variant="h6"> {t.adequacy.name} </Typography>
                                            </Grid>
                                            <Grid item xs={12}  md={4}>
                                                {write_access &&
                                                <Button variant="outlined" size="small"
                                                        onClick={prevState => handleSelectAssessment(t.uuid as number)}>Set</Button>}
                                            </Grid>
                                            <div>{t.description}</div>
                                            <br/>
                                        </Grid>
                                    </Paper>
                                </Grid>

                            )
                        })

                    }
                </Grid>
                <Typography variant="h6"> Data Gaps</Typography>

                <DataGaps assessment_template_group_id={template_group_id} template_id={template_id}/>

            </Grid>
        </div>);
}

export default AdequacyDetails;
